export const EXPERIMENT_VALUES = {};

type Experiments = {
  [key: string]: boolean | string;
};

export const EXPERIMENT_DEFAULT_VALUES: Experiments = {
  noFreeTrials: false,
};

// This need to be in sync with src/common/scss/variables.scss
export const BREAKING_POINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const EMAIL_ADDRESSES = {
  sales: 'sales@streamable.com',
  support: 'support@streamable.com',
};

export const SOCIAL_MEDIA_LINKS = {
  twitter: 'https://twitter.com/streamable',
};

// Legal & policy links. Keep these in sync with the Streamable Help Center.
export const LEGAL_LINKS = {
  termsOfService:
    'https://streamable-support.zendesk.com/hc/en-us/articles/44623209368468-Terms-of-Service',
  privacyPolicy:
    'https://streamable-support.zendesk.com/hc/en-us/articles/44623215636372-Streamable-Privacy-Policy',
  communityGuidelines:
    'https://streamable-support.zendesk.com/hc/en-us/articles/35415811304212-Streamable-Community-Guidelines',
  lawEnforcementGuidelines:
    'https://streamable-support.zendesk.com/hc/en-us/articles/44623268184724-Streamable-Guidelines-for-Law-Enforcement',
  contentModerationPolicy:
    'https://streamable-support.zendesk.com/hc/en-us/articles/54121210288020-Content-Moderation-Policy',
  reportIntimateImages:
    'https://streamable-support.zendesk.com/hc/en-us/articles/54121713664276-Removal-of-Nonconsensual-Intimate-Visual-Depictions-Information-Page',
  reportForm:
    'https://streamable-support.zendesk.com/hc/en-us/requests/new?ticket_form_id=35289293049108',
};

export const ONETRUST_SCRIPT_CATEGORIES = {
  technical: 'optanon-category-C0001',
  analytics: 'optanon-category-C0002',
  functional: 'optanon-category-C0003',
  profiling: 'optanon-category-C0004',
  socialmedia: 'optanon-category-C0005',
};
